(function () {
"use strict";
var CATALOG = window.F5_CATALOG || [];
var BRANDED = CATALOG.length > 0;
var brand = CATALOG.map(function (p) { return { on: p.on, qty: p.def, yld: p.units }; });
var custom = [];
var nextId = 1;
function money(n) {
return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function money0(n) { return "$" + Math.round(n).toLocaleString("en-US"); }
function el(id) { return document.getElementById(id); }
function esc(s) {
return String(s).replace(/[&<>"']/g, function (c) {
return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
});
}
function num(id) {
var v = parseFloat(el(id).value);
return isFinite(v) && v >= 0 ? v : 0;
}
var list = el("skuList");
CATALOG.forEach(function (p, i) {
var row = document.createElement("div");
row.className = "sku";
row.setAttribute("data-on", p.on ? "1" : "0");
row.innerHTML =
'<div class="sku-main">' +
'<input class="row-toggle" type="checkbox" id="on' + i + '"' + (p.on ? " checked" : "") + '>' +
'<div class="sku-info">' +
'<label class="sku-name" for="on' + i + '">' + p.name + (p.est ? ' <span class="est">est</span>' : "") + '</label>' +
'<div class="sku-meta"><span class="sku-sku">' + p.sku + '</span> &middot; ' + p.spec +
(p.kit ? "" : ' &middot; ' + money0(p.price) + ' for ' + p.units + ' ' + p.unit) + '</div>' +
(p.kit
? '<div class="yield-line">' + money0(p.price) + ' per kit covers' +
'<input type="number" id="y' + i + '" min="1" step="1" value="' + p.units +
'" aria-label="Treatments per kit for ' + p.name + '">' +
'treatments, so <b id="k' + i + '"></b> each</div>'
: "") +
'</div>' +
'<div class="sku-foot">' +
'<div class="sku-qty">' +
'<input type="number" id="q' + i + '" min="0" step="' + p.step + '" value="' + p.def + '">' +
'<span class="unit">' + p.unit + ' per treatment' +
(p.ml ? '<b id="v' + i + '"></b>' : "") + '</span>' +
'</div>' +
'<div class="sku-cost" id="c' + i + '">&mdash;</div>' +
'</div>' +
'<span></span>' +
'</div>';
list.appendChild(row);
el("on" + i).addEventListener("change", function (e) {
brand[i].on = e.target.checked;
row.setAttribute("data-on", e.target.checked ? "1" : "0");
render();
});
el("q" + i).addEventListener("input", function (e) {
var v = parseFloat(e.target.value);
brand[i].qty = isFinite(v) && v >= 0 ? v : 0;
render();
});
if (p.kit) {
el("y" + i).addEventListener("input", function (e) {
var v = parseFloat(e.target.value);
brand[i].yld = isFinite(v) && v > 0 ? v : 0;
render();
});
}
});
var customList = el("customList");
function drawCustom() {
el("customLabel").style.display = custom.length ? "" : "none";
customList.innerHTML = "";
custom.forEach(function (c) {
var row = document.createElement("div");
row.className = "sku";
row.setAttribute("data-on", c.on ? "1" : "0");
row.innerHTML =
'<div class="sku-main">' +
'<input class="row-toggle" type="checkbox"' + (c.on ? " checked" : "") + '>' +
'<div class="sku-info">' +
'<label class="sku-name">' + esc(c.name) + '</label>' +
'<div class="sku-meta">' + money(c.price) + ' for ' + (+c.units.toFixed(2)) + ' use' +
(c.units === 1 ? "" : "s") + '</div>' +
'</div>' +
'<div class="sku-foot">' +
'<div class="sku-qty">' +
'<input type="number" min="0" step="0.5" value="' + c.qty + '">' +
'<span class="unit">uses per treatment</span>' +
'</div>' +
'<div class="sku-cost">&mdash;</div>' +
'</div>' +
'<button class="kill" type="button" title="Remove this step" aria-label="Remove ' + esc(c.name) + '">&times;</button>' +
'</div>';
row.querySelector(".row-toggle").addEventListener("change", function (e) {
c.on = e.target.checked;
row.setAttribute("data-on", c.on ? "1" : "0");
render();
});
row.querySelector(".sku-qty input").addEventListener("input", function (e) {
var v = parseFloat(e.target.value);
c.qty = isFinite(v) && v >= 0 ? v : 0;
render();
});
row.querySelector(".kill").addEventListener("click", function () {
custom = custom.filter(function (x) { return x.id !== c.id; });
drawCustom();
render();
});
c._costEl = row.querySelector(".sku-cost");
customList.appendChild(row);
});
}
function addCustom() {
var name = el("nName").value.trim();
if (!name) { el("nName").focus(); return; }
var units = parseFloat(el("nUnits").value);
custom.push({
id: nextId++,
name: name,
price: num("nPrice"),
units: isFinite(units) && units > 0 ? units : 1,
qty: num("nQty"),
on: true
});
el("nName").value = "";
el("nPrice").value = "";
el("nUnits").value = "1";
el("nQty").value = "1";
drawCustom();
render();
el("nName").focus();
}
el("addBtn").addEventListener("click", addCustom);
["nName", "nPrice", "nUnits", "nQty"].forEach(function (id) {
el(id).addEventListener("keydown", function (e) {
if (e.key === "Enter") { e.preventDefault(); addCustom(); }
});
});
el("resetBtn").addEventListener("click", function () {
CATALOG.forEach(function (p, i) {
brand[i].on = p.on;
brand[i].qty = p.def;
brand[i].yld = p.units;
el("on" + i).checked = p.on;
el("q" + i).value = p.def;
if (p.kit) el("y" + i).value = p.units;
list.children[i].setAttribute("data-on", p.on ? "1" : "0");
});
custom = [];
drawCustom();
render();
});
["svcPrice", "svcVol", "ptkQty", "ptkCost", "ptkPrice", "targetPct"].forEach(function (id) {
el(id).addEventListener("input", render);
});
function render() {
var price = num("svcPrice");
var vol = num("svcVol");
var rows = [];
var total = 0;
CATALOG.forEach(function (p, i) {
var q = brand[i].qty;
var cost = 0, txPer = 0, perUnit = 0;
if (p.kit) {
perUnit = brand[i].yld > 0 ? p.price / brand[i].yld : 0;
cost = perUnit * q;
txPer = q > 0 ? brand[i].yld / q : 0;
var kEl = el("k" + i);
if (kEl) kEl.textContent = money(perUnit);
} else {
cost = (p.price / p.units) * q;
txPer = q > 0 ? p.units / q : 0;
}
if (!brand[i].on) cost = 0;
if (brand[i].on) total += cost;
el("c" + i).innerHTML = brand[i].on ? money(cost) : "&mdash;";
if (p.ml) {
var vEl = el("v" + i);
if (vEl) vEl.textContent = " · " + (+(q * p.ml).toFixed(2)) + " mL";
}
if (brand[i].on) {
rows.push({
name: p.name, cost: cost,
amount: (+q.toFixed(2)) + " " + (q === 1 ? p.unit.replace(/s$/, "") : p.unit),
dose: p.ml ? q * p.ml : 0,
txPer: txPer, monthly: cost * vol,
containers: txPer > 0 ? vol / txPer : 0
});
}
});
custom.forEach(function (c) {
var cost = c.on ? (c.price / c.units) * c.qty : 0;
if (c.on) total += cost;
if (c._costEl) c._costEl.innerHTML = c.on ? money(cost) : "&mdash;";
if (c.on) {
var txPer = c.qty > 0 ? c.units / c.qty : 0;
rows.push({
name: c.name, cost: cost, dose: 0,
amount: (+c.qty.toFixed(2)) + " use" + (c.qty === 1 ? "" : "s"),
txPer: txPer, monthly: cost * vol,
containers: txPer > 0 ? vol / txPer : 0
});
}
});
var stepsEl = el("rSteps");
if (stepsEl) {
stepsEl.textContent = rows.length
? rows.length + (rows.length === 1 ? " step" : " steps") + " in the protocol"
: "Nothing selected yet";
}
var pctEl = el("rPct"), pill = el("rBandPill");
var needle = el("rNeedle"), tmark = el("rTmark");
var tgt = num("targetPct");
tmark.style.left = Math.min(tgt / 50 * 100, 100).toFixed(1) + "%";
if (price > 0 && total > 0) {
var pct = (total / price) * 100;
pctEl.textContent = pct.toFixed(1) + "%";
needle.style.left = Math.min(pct / 50 * 100, 100).toFixed(1) + "%";
var band, cls;
if (tgt <= 0)             { band = "Set a target";     cls = "warn"; }
else if (pct <= tgt)      { band = "At or under target"; cls = "good"; }
else if (pct <= tgt * 1.5){ band = "Over target";      cls = "warn"; }
else                      { band = "Well over target"; cls = "crit"; }
pill.textContent = band;
pill.className = "pill " + cls;
} else {
pctEl.innerHTML = "&mdash;";
needle.style.left = "0%";
pill.innerHTML = "&mdash;";
pill.className = "pill good";
}
el("rKeep").textContent = price > 0 ? money(price - total) : "—";
el("rSpend").textContent = money0(total * vol);
el("rKeepMonth").textContent = price > 0 ? money0((price - total) * vol) : "—";
el("barCost").textContent = money(total);
el("barPct").textContent = (price > 0 && total > 0) ? ((total / price) * 100).toFixed(1) + "%" : "—";
el("barKeep").textContent = price > 0 ? money(price - total) : "—";
el("rTarget").textContent = (tgt > 0 && total > 0) ? money0(total / (tgt / 100)) : "—";
var host = el("breakdown");
if (!rows.length) {
host.innerHTML = '<p class="empty">Select at least one step to see the breakdown.</p>';
} else {
var html = '<table><thead><tr><th>Step</th><th>Amount used</th><th>Dose</th><th>Cost per treatment</th>' +
'<th>Treatments per container</th><th>Containers / month</th><th>Spend / month</th></tr></thead><tbody>';
rows.forEach(function (r) {
html += '<tr><td>' + esc(r.name) + '</td>' +
'<td>' + esc(r.amount) + '</td>' +
'<td>' + (r.dose ? (+r.dose.toFixed(2)) + " mL" : "&mdash;") + '</td>' +
'<td>' + money(r.cost) + '</td>' +
'<td>' + (r.txPer > 0 ? (r.txPer >= 10 ? Math.floor(r.txPer) : (+r.txPer.toFixed(1))).toLocaleString("en-US") : "—") + '</td>' +
'<td>' + (r.containers > 0 ? r.containers.toFixed(1) : "—") + '</td>' +
'<td>' + money0(r.monthly) + '</td></tr>';
});
html += '</tbody><tfoot><tr><td>Total</td><td></td><td></td><td>' + money(total) +
'</td><td></td><td></td><td>' + money0(total * vol) + '</td></tr></tfoot></table>';
host.innerHTML = html;
}
var m = num("ptkPrice") - num("ptkCost");
el("ptkMargin").textContent = money(m);
el("ptkMonth").textContent = money0(m * num("ptkQty"));
}
if (!BRANDED) {
el("brandLabel").style.display = "none";
el("resetBtn").style.display = "none";
el("adderIntro").hidden = false;
el("customLabel").textContent = "Your protocol";
el("svcName").value = "My signature facial";
}
drawCustom();
render();
})();